import * as React from 'react'
import { SVGProps } from 'react'
const SvgTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="3.75 0 22 29"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.425 6.228c.494 0 .917.307 1.087.741a2.922 2.922 0 0 0 2.08 2.08c.434.17.741.593.741 1.087v8.517c0 .494-.307.917-.741 1.087a2.922 2.922 0 0 0-2.08 2.08c-.17.434-.593.741-1.087.741H5.575c-.494 0-.917-.307-1.087-.741a2.922 2.922 0 0 0-2.08-2.08 1.167 1.167 0 0 1-.741-1.087v-8.517c0-.494.307-.916.741-1.086a2.922 2.922 0 0 0 2.08-2.08c.17-.435.593-.742 1.087-.742h17.85Zm-8.71 2.781a.7.7 0 0 0-.838.346l-.043.105-.897 2.782-2.924-.006a.7.7 0 0 0-.498 1.193l.086.074 2.37 1.714-.91 2.778a.7.7 0 0 0 .98.843l.098-.06 2.361-1.723 2.361 1.723a.7.7 0 0 0 1.105-.672l-.027-.111-.91-2.778 2.37-1.714a.7.7 0 0 0-.299-1.258l-.113-.009-2.923.006-.898-2.782a.7.7 0 0 0-.451-.451Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgTicket
